

export const App_Project_CheckPlugins = "@@APP-PROJECT-CheckPlugins";
export const App_Project_Upload = "@@APP-PROJECT-UPLOAD";
export const App_Project_ClosePluginModal = "@@APP-PROJECT-CLOSE_PLUGIN_MODAL";
export const App_Project_ShowPluginModal = "@@APP-PROJECT-SHOW_PLUGIN_MODAL";

export const App_Modal_Relations_show = "@@APP-MODAL-MANY_RELATION_SHOW";
export const App_Modal_Relations_hide = "@@APP-MODAL-MANY_RELATION_HIDE";
export const App_Modal_Relations_changeValue = "@@APP-MODAL-MANY_RELATION_CHANGE_VALUE";